export type PortalOrgLevel = 'Company' | 'Site' | 'Asset';

export function getNotesFromJQElement(orgId: string, orgType: PortalOrgLevel) {
  if (orgType === 'Asset') {
    return $('#' + orgId + ' .tile-notes');
  }
  return $('#' + orgId + '.asset-tile__item .asset-tile-notes');
}
